module.exports = __webpack_public_path__ + "static/media/CrossModBannerImageMobile.cbd5cf7b.jpg";